const AUTHENTICATION_FEATURE_KEY = "authentication";
const BLUEM_REGISTRATION_FEATURE_KEY = "BluemRegistration";
const SOCIAL_NETWORK_FEATURE_KEY = "socialNetwork";
const PROVINCES_FEATURE_KEY = "provinces";
const GVIVE_VALIDATION_FEATURE_KEY = "gviveValidation";
export {
  AUTHENTICATION_FEATURE_KEY,
  BLUEM_REGISTRATION_FEATURE_KEY,
  GVIVE_VALIDATION_FEATURE_KEY,
  PROVINCES_FEATURE_KEY,
  SOCIAL_NETWORK_FEATURE_KEY
};
